import { Component } from '@angular/core';

@Component({
  selector: 'app-workshop-jobcard-quote-search-loader',
  templateUrl: './workshop-jobcard-quote-search-loader.component.html',
  styleUrls: ['./workshop-jobcard-quote-search-loader.component.scss']
})
export class WorkshopJobcardQuoteSearchLoaderComponent {

}
